import {Utils} from '../../app.base'
import {MsgBox, Vue} from '../../app.vues';

import SwbMerchtDevcDefSave from './MerchtDevcDefSave';

Vue.regist(SwbMerchtDevcDefSave);

import SwbMerchtDevcDefDetail from './MerchtDevcDefDetail';

Vue.regist(SwbMerchtDevcDefDetail);

import SwbMerchtDevcManualDetail from './MerchtDevcManualDetail';

Vue.regist(SwbMerchtDevcManualDetail);

// import SwbDevcDefRelShopDeviceList from './DevcDefRelShopDeviceList';
// Vue.regist(SwbDevcDefRelShopDeviceList);

import SwbMerchtDevcDefListForSelect from './MerchtDevcDefListForSelect';

Vue.regist(SwbMerchtDevcDefListForSelect);

import SwbMerchtDevcDefImpCheck from './MerchtDevcDefImpCheck';

Vue.regist(SwbMerchtDevcDefImpCheck);

import SwbMerchtDevcManualSave from './MerchtDevcManualSave';

Vue.regist(SwbMerchtDevcManualSave);

import SwbMerchtDevcManualListForSelect from './MerchtDevcManualListForSelect';

Vue.regist(SwbMerchtDevcManualListForSelect);

// 资产定义保存
export function openDevcDefSaveDlg(dlgConfig, callback) {
    let id = dlgConfig['id'];
    let normalized = dlgConfig['normalized'] != null ? dlgConfig['normalized'] : false;
    let assetType = dlgConfig['assetType'];
    let assetTypeDisabled = dlgConfig['assetTypeDisabled'] != null ? dlgConfig['assetTypeDisabled'] : false; // 管理方式禁用
    let purchFlagDisabled = dlgConfig['purchFlagDisabled'] != null ? dlgConfig['purchFlagDisabled'] : false; // 可采购禁用
    let addVersion = dlgConfig['addVersion'];
    let showApplyBtn = Utils.isTrue(dlgConfig['showApplyBtn']); // 是否展示申请按钮
    let row = dlgConfig['row'];
    let title = Utils.isNoB(id) ? "资产定义 - 新增" : "资产定义 - 编辑";
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 850,
        showCloseBtn: true,
        extVisible: showApplyBtn,
        extText: '申请',
        template: '<div class = "">' +
            '<swb-mercht-devc-def-save :defId="defId" :row="row" :normalized="normalized" :assetType="assetType" :assetTypeDisabled="assetTypeDisabled" :purchFlagDisabled="purchFlagDisabled" :addVersion="addVersion" ref="swb_mercht_devc_def_save"></swb-mercht-devc-def-save>' +
            '</div>',
        data: {
            defId: id,
            row: row,
            normalized: normalized,
            assetTypeDisabled: assetTypeDisabled,
            purchFlagDisabled: purchFlagDisabled,
            addVersion: addVersion,
            assetType: assetType
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_mercht_devc_def_save.getDlgResult();
            if (result != null) {
                if (result.type == 'info') {
                    let devcDef = result.data;
                    //
                    callback(devcDef, theDlg, false);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        extClicked: function () {
            let self = this;
            let result = self.$refs.swb_mercht_devc_def_save.getDlgResult();
            if (result != null) {
                if (result.type == 'info') {
                    let devcDef = result.data;
                    //
                    callback(devcDef, theDlg, true);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbMerchtDevcDefFiscalSave from './MerchtDevcDefFiscalSave';

Vue.regist(SwbMerchtDevcDefFiscalSave);

// 资产定义 - 标准化
export function openDevcDefFiscalSaveDlg(dlgConfig, callback) {
    let id = dlgConfig['id'];
    let assetType = dlgConfig['assetType'];
    let fiscalAudit = dlgConfig['fiscalAudit'];
    let title = '资产定义 - 财务完善';
    if (Utils.isTrue(fiscalAudit)) {
        title = '资产定义 - 财务审核';
    }
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 600,
        height: 600,
        showCloseBtn: true,
        template: '<div class = "">' +
            '<swb-mercht-devc-def-fiscal-save :defId="defId" :assetType="assetType" :fiscalAudit="fiscalAudit" ref="swb_mercht_devc_def_fiscal_save"></swb-mercht-devc-def-fiscal-save>' +
            '</div>',
        data: {
            defId: id,
            assetType: assetType,
            fiscalAudit: fiscalAudit
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_mercht_devc_def_fiscal_save.getDlgResult();
            if (result != null) {
                if (result.type == 'info') {
                    let devcDef = result.data;
                    //
                    callback(devcDef, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 资产定义查看
export function openDevcDefDetailDlg(id) {
    //
    let theDlg = Vue.$showDialog({
        title: "资产定义 - 详情",
        width: 1000,
        height: 850,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
            '<swb-mercht-devc-def-detail :defId="defId" ref="swb_mercht_devc_def_detail"></swb-mercht-devc-def-detail>' +
            '</div>',
        data: {
            defId: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbMerchtDevcDefAuditRecList from './MerchtDevcDefAuditRecList';

Vue.regist(SwbMerchtDevcDefAuditRecList);

// 定义审核操作记录
export function openMerchtDevcDefAuditRecListDlg(id) {
    //
    let theDlg = Vue.$showDialog({
        title: "定义 - 审核记录",
        width: 1200,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
            '<swb-mercht-devc-def-audit-rec-list :devcDefId="devcDefId" ref="swb_mercht_devc_manual_detail"></swb-mercht-devc-def-audit-rec-list>' +
            '</div>',
        data: {
            devcDefId: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 资料手册查看
export function openDevcManualDetailDlg(id) {
    //
    let theDlg = Vue.$showDialog({
        title: "资料手册 - 查看",
        width: 1200,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
            '<swb-mercht-devc-manual-detail :defId="defId" ref="swb_mercht_devc_manual_detail"></swb-mercht-devc-manual-detail>' +
            '</div>',
        data: {
            defId: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbMerchtDevcDefRelAccAsmbl from './MerchtDevcDefRelAccAsmbl';

Vue.regist(SwbMerchtDevcDefRelAccAsmbl);

// 资产定义关联组装件
export function openMerchtDevcDefRelAccAsmblDlg(dlgConfig, callback) {
    let devcDef = dlgConfig['devcDef'];
    //
    let theDlg = Vue.$showDialog({
        title: "资产定义 - 关联组装件",
        width: 1000,
        height: 750,
        showCloseBtn: true,
        template: '<div class = "">' +
            '<swb-mercht-devc-def-rel-acc-asmbl :devcDef="devcDef" ref="swb_mercht_devc_def_rel_acc_asmbl"></swb-mercht-devc-def-rel-acc-asmbl>' +
            '</div>',
        data: {
            devcDef: devcDef
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_mercht_devc_def_rel_acc_asmbl.getDlgResult();
            if (result != null) {
                if (result.type == 'info') {
                    let merchtDevcAccAsmblRels = result.data;
                    //
                    callback(merchtDevcAccAsmblRels, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 资产定义选择列表
export function showMerchtDevcDefSelectDlg(dlgConfig, callback) {
    let title = dlgConfig["title"] || "资产定义 - 选择";
    let metaConfKey = dlgConfig["metaConfKey"];
    let catId = dlgConfig["catId"];
    let brandId = dlgConfig["brandId"];
    let modelSpec = dlgConfig["modelSpec"];
    let checkBox = dlgConfig["checkBox"] == null ? false : dlgConfig["checkBox"];
    let required = dlgConfig["required"] == null ? true : dlgConfig["required"];
    let tempOnly = dlgConfig["tempOnly"] == null ? false : dlgConfig["tempOnly"];
    let selectIds = dlgConfig["selectIds"] || [];
    let assetType = dlgConfig["assetType"];
    let normalized = dlgConfig["normalized"];
    let exceptDevcDefId = dlgConfig["exceptDevcDefId"] || null; // 除了指定定义以外的定义
    let filter = dlgConfig["filter"] || {};
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-mercht-devc-def-list-for-select :metaConfKey="metaConfKey" :catId="catId" :brandId="brandId" :modelSpec="modelSpec" :assetType="assetType" :checkBox="checkBox" :required="required" :tempOnly="tempOnly" :normalized="normalized" :selectIds="selectIds" :exceptDevcDefId="exceptDevcDefId" :filter="filter" ref="swb_mercht_devc_def_list_for_select"></swb-mercht-devc-def-list-for-select>',
        data: {
            catId: catId,
            brandId: brandId,
            modelSpec: modelSpec,
            assetType: assetType,
            checkBox: checkBox,
            required: required,
            tempOnly: tempOnly,
            selectIds: selectIds,
            normalized: normalized,
            exceptDevcDefId: exceptDevcDefId,
            filter: filter,
            metaConfKey: metaConfKey
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_mercht_devc_def_list_for_select.getDlgResult() || {};
                if (result.type === 'info') {
                    let devcDefList = result.data || [];
                    callback(devcDefList, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

import devcDefApi from '../../api/devcDef'

// 资产定义导入检查
export function openDevcDefImpCheckDlg(fileObj, scopeId, callback) {
    let theDlg = null;
    theDlg = Vue.$showDialog({
        title: "资产定义导入 - 检查",
        width: -100,
        height: -150,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-mercht-devc-def-imp-check @other-close="otherClose" :scopeId="scopeId" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_mercht_devc_def_imp_check"></swb-mercht-devc-def-imp-check>',
        data: {
            scopeId: scopeId,
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680,
        },
        methods: {
            dlgBodyResized(width, height) {
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            // doDeviceImpModelImport(devcDefImpDto){
            //
            //     let theLoading = MsgBox.loading("正在执行导入");
            //     devcDefApi.doDevcDefImpModelImport(devcDefImpDto, function (result) {
            //         theLoading.close();
            //         if(result.type == 'info') {
            //             if(Utils.isNoB(result.data.errMsg)) {
            //                 callback(result.data);
            //                 theDlg.close();
            //             } else {
            //                 MsgBox.warning(result.data.errMsg);
            //             }
            //         } else {
            //             MsgBox.warning(result.message);
            //         }
            //     });
            // },
            otherClose() {
                callback({
                    importStatis: null
                });
                theDlg.close();
            }
        },
        okClicked: function () {
            // let self = this;
            // let devcDefImpDto = self.$refs.swb_mercht_devc_def_imp_check.getDlgResult() || {};
            // // 判断全部的状态是否是ok
            // let devcDefImpInfoList = devcDefImpDto.impInfoList;
            // if(devcDefImpInfoList.length > 500) {
            //     MsgBox.warning("数据较多，请使用逐条检查导入");
            //     return false;
            // }
            // //
            // self.doDeviceImpModelImport(devcDefImpDto);
            // return false;
        },
        cancelClicked: function () {
            // let self = this;
            // let devcDefImpDto = self.$refs.swb_mercht_devc_def_imp_check.getDlgResult() || {};
            // let devcDefImpInfoList = devcDefImpDto.impInfoList;
            // //
            // if(devcDefImpInfoList.length > 500) {
            //     MsgBox.warning("数据较多，请使用逐条检查导入");
            //     return false;
            // }
            // let theLoading = MsgBox.loading("正在检查导入数据");
            // devcDefApi.validateDevcDefImpModel(devcDefImpDto, function (result) {
            //     theLoading.close();
            //
            //     if(result.data != null) {
            //         self.$refs.swb_mercht_devc_def_imp_check.dlgSetDevcDefImpDto(result.data);
            //     }
            //     console.log(result);
            //     if(result.type != 'info') {
            //         MsgBox.warning(Utils.replace(result.message || '未知错误', '\n', '<br/>'));
            //     } else {
            //         Toast.show(result.message || '数据验证通过', 5000, 'info');
            //     }
            // });
            // return false;
        }
    });
}

// 资料手册保存
export function openDevcManualSaveDlg(id, callback) {
    let title = Utils.isNoB(id) ? "资料手册 - 新增" : "资料手册 - 编辑";
    let width = Utils.isNoB(id) ? 700 : 600;
    let height = Utils.isNoB(id) ? 700 : 300;
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: width,
        height: height,
        showCloseBtn: true,
        template: '<div class = "">' +
            '<swb-mercht-devc-manual-save :manualId="manualId" ref="swb_mercht_devc_manual_save"></swb-mercht-devc-manual-save>' +
            '</div>',
        data: {
            manualId: id
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_mercht_devc_manual_save.getDlgResult();
            if (result != null) {
                if (result.type == 'info') {
                    let resultData = result.data;
                    //
                    callback(resultData, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 资料手册选择列表
export function showMerchtDevcManualSelectDlg(dlgConfig, callback) {
    let title = dlgConfig["title"] || "资料手册 - 选择";
    let checkBox = dlgConfig["checkBox"] == null ? false : dlgConfig["checkBox"];
    let selectIds = dlgConfig["selectIds"] || [];
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 800,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-mercht-devc-manual-list-for-select :checkBox="checkBox" :selectIds="selectIds" ref="swb_mercht_devc_manual_list_for_select"></swb-mercht-devc-manual-list-for-select>',
        data: {
            checkBox: checkBox,
            selectIds: selectIds
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_mercht_devc_manual_list_for_select.getDlgResult() || {};
                if (result.type === 'info') {
                    let devcManualList = result.data || [];
                    callback(devcManualList, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

import SwbDeprSpecDetail from './DeprSpecDetail'

Vue.regist(SwbDeprSpecDetail)

export function openDeprSpecDetailDlg(id) {
    //
    let theDlg = Vue.$showDialog({
        title: "折旧与分摊规则 - 查看",
        width: 500,
        height: 550,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
            '<swb-depr-spec-detail :id="id"></swb-depr-spec-detail>' +
            '</div>',
        data: {
            id: id
        }
    });
}

import SwbDeprSpecListForSelect from './DeprSpecListForSelect'

Vue.regist(SwbDeprSpecListForSelect)

// 交易记账科目保存
export function openDeprSpecSelectDlg(dlgConfig, callback) {
    let filter = dlgConfig['filter'] || null;
    //
    let theDlg = Vue.$showDialog({
        title: '折旧规格 - 选择',
        width: -400,
        height: -200,
        showCloseBtn: true,
        template: '<div class = "">' +
            '<swb-depr-spec-list-for-select :filter="filter" ref="swb_depr_spec_select"></swb-depr-spec-list-for-select>' +
            '</div>',
        data: {
            filter: filter
        },
        okClicked: function () {
            let result = this.$refs.swb_depr_spec_select.getDlgResult()
            if (result.type != 'info') {
                this.$message.warning(result.message);
            } else {
                callback(result, theDlg);
            }
            return false;
        }
    })
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/devcDef/showDlg.js
// module id = 48
// module chunks = 0